import { render } from "./FollowUpComponent.vue?vue&type=template&id=032b4a5c"
import script from "./FollowUpComponent.vue?vue&type=script&lang=js"
export * from "./FollowUpComponent.vue?vue&type=script&lang=js"

import "./FollowUpComponent.vue?vue&type=style&index=0&id=032b4a5c&lang=scss"
script.render = render

export default script